// React Imports
import { ReactElement } from "react";

// Third Party Libraries Imports
import moment from "moment";
import clsx from "clsx";
import { ReactSVG } from "react-svg";

interface ViewUserProps {
  onCancel: () => void;
  selectedUser?: any;
  onEdit?: () => void;
}

const ViewUser: React.FC<ViewUserProps> = ({
  onCancel,
  selectedUser,
  onEdit,
}: ViewUserProps): ReactElement => {
  return (
    <div className="flex flex-col w-full px-5 md:px-10 box-border">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between pb-6 border-b-[1px] border-gray-900 mb-5">
        <h3 className=" text-base md:text-lg">View user: {selectedUser?.name}</h3>
        <div className="flex items-start md:items-center mt-3 md:mt-0">
          <button className="flex items-center cursor-pointer rounded-[40px] border-[1px] border-gray-900 py-2 px-4 font-medium text-blue-500 bg-transparent ms-0 md:ms-3">
            Reset Password
            <ReactSVG className="ms-3" src={"/images/key.svg"} />
          </button>
          <button
            className="flex items-center cursor-pointer rounded-[40px] border-[1px] border-gray-900 py-2 px-4 font-medium text-blue-500 bg-transparent ms-3"
            onClick={onEdit}
          >
            Edit
            <ReactSVG className="ms-3" src={"/images/edit-option.svg"} />
          </button>
        </div>
      </div>
      <div className="border-b-[1px] border-gray-900">
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">ID</p>
          <span className=" font-medium">{selectedUser?.id}</span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">Username</p>
          <span className=" font-medium">{selectedUser?.name}</span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px] break-keep">Email</p>
          <span className=" font-medium">{selectedUser?.email}</span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">Status</p>
          <span className={clsx(
            "rounded bg-gray-600 text-xs font-medium w-fit py-2 px-3",
            selectedUser?.isActive
              ? "bg-gray-600 text-green-500"
              : "bg-pink-200 text-pink-300"
          )}>
            {selectedUser?.isActive ? "Active" : "Inactive"}
          </span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">Role</p>
          <span className=" font-medium">
            {selectedUser?.roles?.map((role: any) => role.role).join(", ")}
          </span>
        </div>
        <div className="flex items-center pb-3 border-b-[1px] border-gray-900 mb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">Created At</p>
          <span className=" font-medium">
            {moment(selectedUser?.createdAt).format("DD MMM, YYYY hh:mm A")}
          </span>
        </div>
        <div className="flex items-center pb-3">
          <p className=" min-w-[110px] md:min-w-[200px]">Updated At</p>
          <span className=" font-medium">
            {moment(selectedUser?.updatedAt).format("DD MMM, YYYY hh:mm A")}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-end">
        <button
          onClick={onCancel}
          className=" w-1/3 cursor-pointer rounded-xl border-[1px] border-blue-500 py-3 px-4 text-base bg-transparent text-blue-500 mt-5 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ViewUser;
